// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {alertService} from "../../../../services/AlertService";

import TableCard from "../../../../components/tablecard/TableCard";
import Loading from "../../../../components/loading/Loading";

import {getIzinTransaksi, insertIzinTransaksi, izinTransaksiSelector, updateIzinTransaksi,} from "./izinTransaksiSlice";
import {getMinKaryawan, karyawanSelector} from "../../karyawan/karyawanSlice";
import {jabatanSelector,} from "../../../master/jabatan/jabatanSlice";

import {bagianSelector,} from "../../../master/bagian/bagianSlice";
import {Colors} from "../../../../assets/Colors";

function isRequired(value) {
    let status = false;
    if (value !== null) {
        if (typeof value === "number") {
            if (value !== -1) {
                status = true;
            }
        }

    }
    return status;
}

function isSame(value1, value2) {
    return value1 === value2;
}

function useForm(initialState = {}, validations = [], onSubmit = () => {
}) {
    const {isValid: initialIsValid, errors: initialErrors} = validate(
        validations,
        initialState
    );
    const [changed, setChanged] = useState(false);
    const [values, setValues] = useState(initialState);
    const [errors, setErrors] = useState(initialErrors);
    const [isValid, setValid] = useState(initialIsValid);
    const [touched, setTouched] = useState({});

    const changeHandler = (event) => {
        const newValues = {...values, [event.target.name]: event.target.value};
        const {isValid, errors} = validate(validations, newValues);
        setChanged(true);
        setValues(newValues);
        setValid(isValid);
        setErrors(errors);
        setTouched({...touched, [event.target.name]: true});
    };

    const editHandler = (initValues) => {
        const newValues = {
            ...values,
            Nik: initValues.Nik,
            JenisIzin: initValues.JenisIzin,
            KeperluanIzin: initValues.KeperluanIzin,
            Pengganti: initValues.Pengganti,
            Tiket: initValues.Tiket,
        };
        setValues(newValues);
    };

    const clearHandler = () => {
        setValues(initialState);
    };

    const submitHandler = (event) => {
        event.preventDefault();
        onSubmit(values);
    };
    return {
        values,
        changeHandler,
        editHandler,
        clearHandler,
        isValid,
        errors,
        touched,
        submitHandler,
    };
}

function validate(validations, values) {
    const errors = validations
        .map((validation) => validation(values))
        .filter((validation) => typeof validation === "object");
    return {
        isValid: errors.length === 0,
        errors: errors.reduce((errors, error) => ({...errors, ...error}), {}),
    };
}

const IzinPage = ({}) => {
    let initialState = {
        JenisIzin: -1,
        KeperluanIzin: "",
        Pengganti: "",
        Tiket: false,
    };

    const validations = [
        ({JenisIzin}) =>
            isRequired(JenisIzin) || {JenisIzin: "Jenis izin wajib diisi"},
        ({KeperluanIzin}) =>
            isRequired(KeperluanIzin) || {
                KeperluanIzin: "Keperluan izin wajib diisi",
            },
    ];

    const {
        changed,
        values,
        isValid,
        errors,
        touched,
        changeHandler,
        editHandler,
        clearHandler,
        submitHandler,
    } = useForm(initialState, validations);
    const [buttonTouched, setButtonTouched] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [TanggalMulai, setTanggalMulai] = useState(new Date());
    const [TanggalAkhir, setTanggalAkhir] = useState(new Date());

    const [JamAwal, setTJamAwal] = useState(new Date());
    const [JamAkhir, setJamAkhir] = useState(new Date());

    const [isValidTanggalMulai, setIsValidTanggalMulai] = useState(true);
    const [isValidTanggalAkhir, setIsValidTanggalAkhir] = useState(true);
    const [dateChanged, setDateChanged] = useState(false);
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);

    const [insertFetch, setInsertFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const izin = useSelector(izinTransaksiSelector);
    const karyawan = useSelector(karyawanSelector);
    const jabatan = useSelector(jabatanSelector);
    const bagian = useSelector(bagianSelector);
    let user = JSON.parse(localStorage.getItem("user"));

    useEffect(() => {
        dispatch(
            getIzinTransaksi({
                start: start,
                count: count,
                search: user.Nik,
            })
        );
    }, []);

    useEffect(() => {
        if (showModalEdit && !showModalAdd) {
            setShowModalAdd(showModalEdit);
            const initValues = {
                Nik: currentData.Nik,
                JenisIzin: currentData.JenisIzin,
                KeperluanIzin: currentData.KeperluanIzin,
                Pengganti: currentData.Pengganti,
                Tiket: currentData.Tiket,
            };
            editHandler(initValues);
            setTanggalMulai(new Date(currentData.TanggalMulai));
            setTanggalAkhir(new Date(currentData.TanggalAkhir));
            // 
            // 
            setTJamAwal(
                new Date(
                    currentData.JamAwal.substring(0, currentData.JamAwal.length - 1)
                )
            );
            setJamAkhir(
                new Date(
                    currentData.JamAkhir.substring(0, currentData.JamAkhir.length - 1)
                )
            );
        }

        if (search !== "" && izin.isGetSuccess && !izin.isGetFetching) {
            let calc = izin?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = izin.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (search === "" && izin.isGetSuccess && !izin.isGetFetching) {
            let calc = izin?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = izin.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (izin.isGetSuccess && maxPage === 0 && firstLoading === false) {
            let calc = izin?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = izin.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getIzinTransaksi({
                    start: start,
                    count: count,
                    search: user.Nik,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (izin.isGetSuccess) {
                alertService.success(izin.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getIzinTransaksi({
                        start: start,
                        count: count,
                        search: user.Nik,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (izin.isUpdateSuccess) {
                alertService.success(izin.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateIzinTransaksi({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetIzin(params) {
    //   return dispatch(getIzinTransaksi(params));
    // }

    function handleInsertIzin(param) {
        setInsertFetch(true);
        const params = {
            namaIzin: param.inputOneValue,
            provinsiID: param.dropdownProvinsiValue,
        };
        dispatch(insertIzinTransaksi(params));
    }

    function handleUpdateIzin(param) {
        setUpdateFetch(true);

        const params = {
            provinsiID: param.dropdownProvinsiValue,
            namaIzin: param.inputOneValue,
            izinID: currentData.IzinID,
            status: param.status,
        };
        dispatch(updateIzinTransaksi(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getIzinTransaksi(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getIzinTransaksi(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = izin.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? izin.count : newCount,
            search: search,
        };
        dispatch(getIzinTransaksi(params));

        setPage(1);
        setCount(newCount === "-1" ? izin.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);

        dispatch(getMinKaryawan({search: ""}));
    }

    let lamaIzin = 0;
    let statusLamaIzin = true;
    if (TanggalMulai !== "" && TanggalAkhir !== "") {
        Math.round(
            (TanggalAkhir.getTime() - TanggalMulai.getTime()) / (1000 * 60 * 60 * 24)
        );
    }

    if (!firstLoading) {
        return <Loading/>;
    } else {
        const selectedNik = karyawan.minData.findIndex((x) => x.Nik === values.Nik);
        return (
            <>
                <div className="md:ml-64">
                    <div
                        style={{background: Colors.primary}}
                        className="pt-14 pb-16 px-3 md:px-8 h-auto"
                    >
                        <div className="container mx-auto max-w-full">
                            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                        </div>
                    </div>

                    <div className="px-3 md:px-8 h-auto -mt-32">
                        <div className="container mx-auto max-w-full">
                            <div className="grid grid-cols-1 px-4">
                                <TableCard
                                    SearchBar={true}
                                    primaryID="TIzinID"
                                    transaksi={true}
                                    handleSearch={handleSearch}
                                    searchPlaceholder="Izin"
                                    updatePage={handleUpdatePage}
                                    updateCount={handleUpdateCount}
                                    currentData={handleCurrentData}
                                    currentPage={page}
                                    maxPage={maxPage}
                                    tableTitle="Master Izin"
                                    tableData={izin.data}
                                    colOneTitle="ID"
                                    colOneData="TIzinID"
                                    colTwoTitle="Nama Karyawan"
                                    colTwoData="NamaKaryawan"
                                    colThreeTitle="Jenis Izin"
                                    colThreeData="JenisIzinKet"
                                    colFourTitle="Keperluan Izin"
                                    colFourData="KeperluanIzin"
                                    colFiveTitle="Tanggal"
                                    colFiveData="TanggalMonitoring"
                                    colSevenTitle="Status Approval"
                                    colSevenData="StatusKet"
                                    fetching={izin.isGetFetching}
                                    modal={handleModal}
                                    editEnabled={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    size="regular"
                    active={showModalAdd}
                    toggler={() => {
                        setShowModalAdd(true);
                    }}
                >
                    <ModalHeader
                        className="mt-20"
                        toggler={() => {
                            setTanggalMulai("");
                            setTanggalAkhir("");
                            setShowModalAdd(false);
                            setShowModalEdit(false);
                            setButtonTouched(false);
                            clearHandler();
                        }}
                    >
                        {showModalEdit ? "Edit Data" : "Tambah Data"}
                    </ModalHeader>
                    <ModalBody>
                        <form className="w-full max-w-lg" onSubmit={submitHandler}>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Jenis Izin *
                                    </label>
                                    <div className="inline-block relative w-full  ">
                                        <select
                                            value={values.JenisIzin}
                                            onChange={changeHandler}
                                            name="JenisIzin"
                                            // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                                            className={
                                                (touched.JenisIzin || buttonTouched) && errors.JenisIzin
                                                    ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                        >
                                            <option defaultValue disabled value={-1} hidden>
                                                -- Pilih Data --
                                            </option>
                                            <option value={1}>Pulang Cepat</option>
                                            <option value={2}>Terlambat Datang</option>
                                            <option value={3}>Keluar Jam Kerja</option>
                                            {selectedNik >= 0 &&
                                                karyawan.minData[selectedNik]["JenisKelamin"] === 0 && (
                                                    <option value={4}>Sakit Khusus Wanita</option>
                                                )}
                                        </select>
                                        <div
                                            className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                            <svg
                                                className="fill-current h-4 w-4"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                            >
                                                <path
                                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                            </svg>
                                        </div>
                                        {(touched.JenisIzin || buttonTouched) &&
                                            errors.JenisIzin && (
                                                <p className="text-red-500 text-xs italic">
                                                    {errors.JenisIzin}
                                                </p>
                                            )}
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-6">
                                <div className="w-full px-3 md:mb-0 mb-6">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Keperluan Izin *
                                    </label>
                                    <input
                                        value={values.KeperluanIzin}
                                        onChange={changeHandler}
                                        name="KeperluanIzin"
                                        className={
                                            (touched.KeperluanIzin || buttonTouched) &&
                                            errors.KeperluanIzin
                                                ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        }
                                        type="text"
                                    />
                                    {(touched.KeperluanIzin || buttonTouched) &&
                                        errors.KeperluanIzin && (
                                            <p className="text-red-500 text-xs italic">
                                                {errors.KeperluanIzin}
                                            </p>
                                        )}
                                </div>
                            </div>
                            {values.JenisIzin === 4 && (
                                <div className="flex flex-wrap -mx-3">
                                    <div className="w-full md:w-1/2 px-3 mb-6">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Tanggal Mulai *
                                        </label>
                                        <DatePicker
                                            className={
                                                !isValidTanggalMulai
                                                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            selected={TanggalMulai}
                                            onChange={(date) => {
                                                setTanggalMulai(date);
                                                setTanggalAkhir("");
                                                setIsValidTanggalMulai(true);
                                                setIsValidTanggalAkhir(false);
                                                if (showModalEdit) {
                                                    setDateChanged(true);
                                                }
                                            }}
                                        />
                                        {!isValidTanggalMulai && (
                                            <p className="text-red-500 text-xs italic">
                                                Tanggal mulai wajib diisi
                                            </p>
                                        )}
                                    </div>
                                    <div className="w-full md:w-1/2 px-3 mb-6">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Tanggal Akhir *
                                        </label>
                                        <DatePicker
                                            className={
                                                !isValidTanggalAkhir
                                                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            disabled={TanggalMulai === ""}
                                            minDate={new Date(TanggalMulai).setDate(
                                                new Date(TanggalMulai).getDate()
                                            )}
                                            selected={TanggalAkhir}
                                            onChange={(date) => {
                                                setTanggalAkhir(date);
                                                setIsValidTanggalAkhir(true);
                                                if (showModalEdit) {
                                                    setDateChanged(true);
                                                }
                                            }}
                                        />
                                        {!isValidTanggalAkhir && (
                                            <p className="text-red-500 text-xs italic">
                                                Tanggal akhir wajib diisi
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}
                            <div className="flex flex-wrap -mx-3">
                                {(values.JenisIzin === 1 || values.JenisIzin === 3) && (
                                    <div className="w-full md:w-1/2 px-3 mb-6">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Jam Awal
                                        </label>
                                        <DatePicker
                                            showTimeSelectOnly
                                            showTimeInput
                                            dateFormat="HH:mm"
                                            selected={new Date(JamAwal)}
                                            className={
                                                "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            onChange={(time) => {
                                                setTJamAwal(time);
                                            }}
                                        />
                                        {!isValidTanggalMulai && (
                                            <p className="text-red-500 text-xs italic">
                                                Tanggal mulai wajib diisi
                                            </p>
                                        )}
                                    </div>
                                )}
                                {(values.JenisIzin === 2 || values.JenisIzin === 3) && (
                                    <div className="w-full md:w-1/2 px-3 mb-6">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Jam Akhir
                                        </label>
                                        <DatePicker
                                            showTimeSelectOnly
                                            showTimeInput
                                            dateFormat="HH:mm"
                                            selected={new Date(JamAkhir)}
                                            className={
                                                "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            onChange={(time) => {
                                                setJamAkhir(time);
                                            }}
                                        />
                                        {!isValidTanggalMulai && (
                                            <p className="text-red-500 text-xs italic">
                                                Tanggal mulai wajib diisi
                                            </p>
                                        )}
                                    </div>
                                )}
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="red"
                            buttonType="link"
                            onClick={() => {
                                setTanggalMulai("");
                                setTanggalAkhir("");
                                setShowModalAdd(false);
                                setShowModalEdit(false);
                                clearHandler();
                            }}
                            ripple="dark"
                        >
                            Cancel
                        </Button>

                        <Button
                            color={
                                (isValid || (showModalEdit && dateChanged && !isValid)) &&
                                isValidTanggalMulai &&
                                isValidTanggalAkhir
                                    ? "green"
                                    : "blueGray"
                            }
                            onClick={() => {
                                if (!isValid && changed) {
                                    setButtonTouched(true);
                                }
                                let tempIsValid = true;
                                if (tempIsValid) {
                                    const tanggal = {
                                        JamAwal: JSON.stringify(JamAwal.toLocaleTimeString()),
                                        JamAkhir: JSON.stringify(JamAkhir.toLocaleTimeString()),
                                        TanggalMulai: JSON.stringify(TanggalMulai),
                                        TanggalAkhir: JSON.stringify(TanggalAkhir),
                                        TIzinID: currentData.TIzinID,
                                    };
                                    const temp = {
                                        ...values,
                                        Nik: user.Nik,
                                    };
                                    setShowModalAdd(false);
                                    setShowModalEdit(false);
                                    if (showModalEdit) {
                                        dispatch(updateIzinTransaksi(Object.assign(temp, tanggal)));
                                    } else {
                                        dispatch(insertIzinTransaksi(Object.assign(temp, tanggal)));
                                    }
                                }
                            }}
                            ripple={
                                isValid && isValidTanggalMulai && isValidTanggalAkhir
                                    ? "light"
                                    : ""
                            }
                        >
                            SUBMIT
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
};

export default IzinPage;
